// extracted by mini-css-extract-plugin
module.exports = {"list":"e_ud","hero":"e_vd"};